<template>
  <div class="car_t">{{ desc }}</div>
</template>

<script>
export default {
  props: {
    desc: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang='scss' scoped>
.car_t {
  padding: 10px 0;
  color: #1890ff;
  border-bottom: 1px solid #e7e7e7;
}
</style>
